export const ADDRESS_TYPES = {
  SHIPPING: 'SHIPPING',
  BILLING: 'BILLING',
} as const

export const NORMALIZATION_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
} as const

export const POSTAL_NORMALIZATION_STATUS = {
  UNKNOWN: 'UNKNOWN',
  NORMALIZED: 'NORMALIZED',
  NORMALIZATION_REJECTED: 'NORMALIZATION_REJECTED',
} as const

export const VALIDATION_RESULT_CODE = {
  UNSUPPORTED_COUNTRY: 'UNSUPPORTED_COUNTRY',
  PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
  US_TERRITORY_UNSUPPORTED: 'US_TERRITORY_UNSUPPORTED',
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
} as const

export type AddressType = (typeof ADDRESS_TYPES)[keyof typeof ADDRESS_TYPES]
export type NormalizationStatus = (typeof NORMALIZATION_STATUS)[keyof typeof NORMALIZATION_STATUS]
export type PostalNormalizationStatus = (typeof POSTAL_NORMALIZATION_STATUS)[keyof typeof POSTAL_NORMALIZATION_STATUS]
export type ValidationResultCode = (typeof VALIDATION_RESULT_CODE)[keyof typeof VALIDATION_RESULT_CODE]

type AddressLike = { confirmed?: boolean; postalNormalizationStatus?: string }

export const isAddressValidated = (address: AddressLike = {}): boolean => {
  const { confirmed, postalNormalizationStatus } = address
  const { NORMALIZED } = POSTAL_NORMALIZATION_STATUS

  const isConfirmed = confirmed === true
  const isNormalized = postalNormalizationStatus === NORMALIZED
  return [isConfirmed, isNormalized].some((condition) => condition === true)
}

export const isBillingAddressType = (addressType: string = ''): boolean => addressType === ADDRESS_TYPES.BILLING

export const isShippingAddressType = (addressType: string = ''): boolean => addressType === ADDRESS_TYPES.SHIPPING

export const getNormalizationStatusForVerifiedAddress = (
  normalizationStatus: string,
): PostalNormalizationStatus | undefined => {
  const { NORMALIZED } = POSTAL_NORMALIZATION_STATUS
  const { VALID, CONFIRMATION_REQUIRED } = NORMALIZATION_STATUS
  let normalizationStatusValue: PostalNormalizationStatus | undefined

  if (([VALID, CONFIRMATION_REQUIRED] as readonly string[]).includes(normalizationStatus)) {
    normalizationStatusValue = NORMALIZED
  }

  return normalizationStatusValue
}
